import { DecorateEditorialHtml, returnCitiCode } from "../../../../ContentUtilities";
import * as React from "react";
import { useLocation } from "react-router";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import { UitkPrimaryButton } from "uitk-react-button";
import { formatText } from "bernie-l10n";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { cardLink } from "stores/wizard/config/overrideConfigBySiteId/siteIds/siteId1";
import { UitkSpacing } from "uitk-react-spacing";

export const CitiCardModalDialogPopUp = (props: { items: EditorialModel[] }) => {
  const { search: searchUrl } = useLocation();
  const CONTENT_ID_COUNT = 8;
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [
    chooseCardText,
    feeCardImage,
    feeCardSubText,
    feeCardOfferText,
    separator,
    noFeeCardImage,
    noFeeCardSubText,
    noFeeCardOfferText,
  ] = items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />);
  const applyNowText = formatText("grid3.citiDesktopStickybar.applyNow.text");
  const citiCode = returnCitiCode(searchUrl);
  const feeCardApplyNowLink = citiCode ? cardLink.feeCardLink + `&citiCode=${citiCode}` : cardLink.feeCardLink;
  const noFeeCardApplyNowLink = citiCode ? cardLink.noFeeCardLink + `&citiCode=${citiCode}` : cardLink.noFeeCardLink;

  return (
    <UitkLayoutGrid rows={1} space="six">
      <UitkLayoutGridItem>
        <div className="uitk-type-center">
          <UitkText align="center" size={600} weight="bold">
            {chooseCardText}
          </UitkText>
        </div>
      </UitkLayoutGridItem>
      <UitkLayoutGridItem>
        <div>
          <UitkSpacing padding={{ blockend: "three" }}>
            <div className="uitk-type-center">{feeCardImage}</div>
          </UitkSpacing>
          <UitkText align="center" size={300} weight="bold">
            {feeCardSubText}
          </UitkText>
          <UitkSpacing padding={{ blockend: "three" }}>
            <UitkText align="center" size={200} weight="bold">
              {feeCardOfferText}
            </UitkText>
          </UitkSpacing>
          <div className="uitk-type-center">
            <UitkPrimaryButton type="button" text={applyNowText} href={feeCardApplyNowLink} />
          </div>
        </div>
      </UitkLayoutGridItem>

      <UitkLayoutGridItem>
        <div className="uitk-type-center">{separator}</div>
      </UitkLayoutGridItem>

      <UitkLayoutGridItem>
        <div>
          <UitkSpacing padding={{ blockend: "three" }}>
            <div className="uitk-type-center">{noFeeCardImage}</div>
          </UitkSpacing>
          <UitkText align="center" size={300} weight="bold">
            {noFeeCardSubText}
          </UitkText>
          <UitkSpacing padding={{ blockend: "three" }}>
            <UitkText align="center" size={200} weight="bold">
              {noFeeCardOfferText}
            </UitkText>
          </UitkSpacing>
          <div className="uitk-type-center">
            <UitkPrimaryButton type="button" text={applyNowText} href={noFeeCardApplyNowLink} />
          </div>
        </div>
      </UitkLayoutGridItem>
    </UitkLayoutGrid>
  );
};
export default CitiCardModalDialogPopUp;
